export function signInRequest(email, password) {
  return {
    type: 'SIGN_IN_REQUEST',
    payload: { email, password },
  };
}

export function signInSuccess(token, user) {
  return {
    type: 'SIGN_IN_SUCCESS',
    payload: { token, user },
  };
}

export function signUpRequest(
  name,
  document,
  phone,
  cellphone,
  email,
  password,
  confirmPassword,
  newsLetter,
  acceptContract
) {
  return {
    type: 'SIGN_UP_REQUEST',
    payload: {
      name,
      document,
      phone,
      cellphone,
      email,
      password,
      confirmPassword,
      newsLetter,
      acceptContract,
    },
  };
}

export function signFailure() {
  return {
    type: 'SIGN_IN_FAILURE',
  };
}

export function handleLoginModal() {
  return {
    type: 'SHOW_LOGIN_MODAL',
  };
}
export function handleCloseLoginModal() {
  return {
    type: 'CLOSE_LOGIN_MODAL',
  };
}

export function signOut() {
  return {
    type: 'SIGN_OUT',
  };
}
export function signOutRequest() {
  return {
    type: 'SIGN_OUT_REQUEST',
  };
}

export function renewToken(token) {
  return {
    type: 'RENEW_TOKEN',
    payload: {
      token,
    },
  };
}

export function changePassword(password, token) {
  return {
    type: 'CHANGE_PASSWORD',
    payload: {
      password,
      token,
    },
  };
}
